import { DefaultTheme } from "styled-components";
import { dark as darkAlert } from "../components/Alert/theme";
import { dark as darkCard } from "../components/Card/theme";
import { dark as darkPancakeToggle } from "../components/PancakeToggle/theme";
import { dark as darkRadio } from "../components/Radio/theme";
import { dark as darkToggle } from "../components/Toggle/theme";
import { dark as darkNavBase } from "../widgets/Menu/theme";
import { dark as darkModal } from "../widgets/Modal/theme";
import { dark as darkTooltip } from "../components/Tooltip/theme";
import base from "./base";

// 过年喜庆的明亮红色主题颜色（类似红包UI）
const redColors = {
  white: 'white',
  failure: '#FF6B6B',
  failure33: '#FF6B6B33',
  primary: '#FFD700', // 黄色（类似红包UI的主要按钮颜色）
  primary0f: '#FFD7000f',
  primary3D: '#FFD7003D',
  primaryBright: '#FFED4E', // 更亮的黄色
  primaryDark: '#FFA500', // 橙色
  success: '#4CAF50',
  success19: '#4CAF5019',
  warning: '#FFB74D', // 黄色警告
  warning2D: '#FFB74D2D',
  warning33: '#FFB74D33',
  binance: '#F0B90B',
  gold: '#FFD700', // 金色
  silver: '#C0C0C0',
  bronze: '#CD7F32',
  secondary: '#FFD700', // 黄色作为次要色（类似红包UI的黄色按钮）
  secondary80: '#FFD70080',
  background: '#FF4444', // 明亮的红色背景（不要黑色）
  backgroundDisabled: '#FF9999',
  backgroundAlt: '#FF5555', // 稍亮的红色背景
  backgroundAlt2: 'rgba(255, 68, 68, 0.9)',
  cardBorder: '#FF6666',
  contrast: '#FFFFFF', // 白色文字
  dropdown: '#FF5555',
  dropdownDeep: '#FF4444',
  invertedContrast: '#FFFFFF',
  input: '#FFFFFF', // 白色输入框
  inputSecondary: '#FFEEEE',
  inputText: '#000000', // 白色输入框内字体改为黑色
  inputPlaceholder: '#666666', // 白色输入框内 placeholder
  tertiary: '#FF6666',
  text: '#FFFFFF', // 白色文字（在红色背景上）
  text99: '#FFFFFF99',
  textDisabled: '#FFCCCC',
  textSubtle: '#FFFFFF', // 白色文字
  disabled: '#FFAAAA',
  gradientBubblegum: 'linear-gradient(139.73deg, #FF4444 0%, #FF6B6B 100%)',
  gradientInverseBubblegum: 'linear-gradient(139.73deg, #E63946 0%, #FF4444 100%)',
  gradientCardHeader: 'linear-gradient(166.77deg, #FF4444 0%, #FF6B6B 100%)',
  gradientBlue: 'linear-gradient(180deg, #FF4444 0%, #FF6B6B 100%)',
  gradientViolet: 'linear-gradient(180deg, #FF4444 0%, #FF6B6B 100%)',
  gradientVioletAlt: 'linear-gradient(180deg, #E63946 0%, #FF4444 100%)',
  gradientGold: 'linear-gradient(180deg, #FFD700 0%, #FFA500 100%)',
  gradientBold: 'linear-gradient(#FF6B6B, #FF4444)',
};

// 红色主题的导航栏配置
const redNav = {
  background: redColors.backgroundAlt, // 使用红色背景
};

// 红色主题的卡片配置（使用明亮的红色背景）
const redCard = {
  background: redColors.backgroundAlt, // 明亮的红色卡片背景
  boxShadow: '0px 2px 8px rgba(255, 68, 68, 0.3)',
  boxShadowActive: '0px 0px 0px 1px #FFD700, 0px 0px 4px 8px rgba(255, 215, 0, 0.4)',
  boxShadowSuccess: '0px 0px 0px 1px #4CAF50, 0px 0px 4px 8px rgba(76, 175, 80, 0.4)',
  boxShadowWarning: '0px 0px 0px 1px #FFB74D, 0px 0px 4px 8px rgba(255, 183, 77, 0.4)',
  cardHeaderBackground: {
    default: redColors.gradientCardHeader,
    blue: redColors.gradientBlue,
    bubblegum: redColors.gradientBubblegum,
    violet: redColors.gradientViolet,
  },
  dropShadow: 'drop-shadow(0px 1px 4px rgba(255, 68, 68, 0.3))',
};

const redTheme: DefaultTheme = {
  ...base,
  isDark: false, // 改为 false，因为不是深色主题
  alert: darkAlert,
  colors: redColors as any,
  card: redCard as any,
  toggle: darkToggle,
  nav: redNav as any,
  modal: darkModal,
  pancakeToggle: darkPancakeToggle,
  radio: darkRadio,
  tooltip: darkTooltip,
};

export default redTheme;
